export default __webpack_public_path__ + "static/media/discovery.8ee7d668.png";